import { WheelData } from "react-custom-roulette/dist/components/Wheel/types";
import "./Wheel4p.scss";
import {
  Fit,
  Layout,
  useRive,
  useStateMachineInput,
} from "@rive-app/react-canvas";
import RivFile from "../../assets/riv/Wheel21.07.2025.riv";
import { useEffect, useRef, useState } from "react";

interface IProps {
  isConsumeLoading: boolean;
  mustStartSpinning: boolean;
  wheelData: WheelData[];
  winnerIndex: number;
  callbackSpin: () => void;
  callbackFinished: () => void;
  hashData: any;
}

const Wheel4P = (props: IProps) => {
  const [anima, setAnima] = useState<string>("waiting");
  const hasFinished = useRef(false);
  const { rive, RiveComponent } = useRive({
    src: RivFile,
    layout: new Layout({ fit: Fit.Cover }),
    stateMachines: anima,
    autoplay: true,
  });

  const spinTrigger = useStateMachineInput(rive, anima, "spin");

  useEffect(() => {
    if (props.hashData?.offers && props.hashData.offerId) {
      const selectedReward = props.hashData.offers.find(
        (item: any) => item.id === props.hashData.offerId
      );
      if (selectedReward) {
        setAnima(selectedReward.attr1);
      }
    }
  }, [props.hashData]);

  const spinFlow = () => {
    console.log("spinFlow");
    try {
      if (spinTrigger) {
        spinTrigger.fire();
      }
      if (!hasFinished.current) {
        props.callbackFinished();
        hasFinished.current = true; 
      }
    } catch (error) {
      console.error("Hata oluştu:", error);
    }
  };

  return (
    <div
      id="wheel4p"
      onClick={() => {
        console.log("clicked");
        spinFlow();
      }}
    >
      <RiveComponent className="riveA" />
    </div>
  );
};

export default Wheel4P;
